import React from 'react';


const CommonLoader = (props) => {
    
    return (
        <>
            
            <div>
                <div style={{padding: "10px", minHeight: "calc(100vh - 25px - 100px - 225px)", marginTop:props.marginTop}}className='d-flex justify-content-center align-items-center'>
                    <div className="spinner-grow text-muted"></div> 
                    <div style={{marginLeft: "5px"}}className="spinner-grow text-muted"></div>
                    <div style={{marginLeft: "5px"}}className="spinner-grow text-muted"></div>
                </div>
            </div>
        </>

    );
}
export default CommonLoader;